import type { EEGTileTransportMode } from "../services/EEGSegmentCache";

export interface PausedHighSpeedInspectHoldState {
  playbackSpeed: number;
  timeScale: number;
  resolutionLevel: number;
  transportMode: EEGTileTransportMode;
}

interface ResolveEegDataPlaybackContextOptions {
  isPlaying: boolean;
  pausedHighSpeedInspectHold: PausedHighSpeedInspectHoldState | null;
  effectivePlaybackSpeed: number;
  effectiveTimeScale: number;
  playbackTransportMode: EEGTileTransportMode;
  autoResolution: boolean;
  resolutionLevel: number;
  getAutoResolutionLevel: (
    speed: number,
    transportMode: EEGTileTransportMode,
  ) => number;
}

export interface ResolvedEegDataPlaybackContext {
  eegDataPlaybackSpeed: number;
  eegDataTimeScale: number;
  eegDataTransportMode: EEGTileTransportMode;
  effectiveResolutionLevel: number;
  eegDataResolutionLevel: number;
}

export function getPausedHighSpeedInspectGraceMs(
  playbackSpeed: number,
): number {
  if (playbackSpeed >= 150) {
    return 2500;
  }

  if (playbackSpeed >= 100) {
    return 2250;
  }

  return 1750;
}

export function shouldCreatePausedPlayTransportHold(
  playbackSpeed: number,
): boolean {
  return Number.isFinite(playbackSpeed) && playbackSpeed > 1;
}

export function resolveEegDataPlaybackContext(
  options: ResolveEegDataPlaybackContextOptions,
): ResolvedEegDataPlaybackContext {
  const activePausedHighSpeedHold =
    !options.isPlaying && options.pausedHighSpeedInspectHold !== null;
  const hold = activePausedHighSpeedHold
    ? options.pausedHighSpeedInspectHold
    : null;

  const eegDataPlaybackSpeed =
    hold?.playbackSpeed ?? options.effectivePlaybackSpeed;
  const eegDataTimeScale = hold?.timeScale ?? options.effectiveTimeScale;
  const eegDataTransportMode =
    hold?.transportMode ?? options.playbackTransportMode;
  const effectiveResolutionLevel =
    hold?.resolutionLevel ??
    (options.autoResolution
      ? options.getAutoResolutionLevel(
          options.effectivePlaybackSpeed,
          options.playbackTransportMode,
        )
      : options.resolutionLevel);
  const eegDataResolutionLevel =
    hold?.resolutionLevel ??
    (options.autoResolution
      ? options.getAutoResolutionLevel(
          eegDataPlaybackSpeed,
          eegDataTransportMode,
        )
      : options.resolutionLevel);

  return {
    eegDataPlaybackSpeed,
    eegDataTimeScale,
    eegDataTransportMode,
    effectiveResolutionLevel,
    eegDataResolutionLevel,
  };
}